import { logger } from '@/services/logger';
import { ApiVoicesResponse, IApiVoice, IVoice, Providers } from '@d-id/types';

const getDeprecationMessage = (voice: IVoice | IApiVoice) => {
    if (voice.isLegacy) {
        return { deprecationMessage: 'This is a Legacy voice that might be discontinued in the future.' };
    }

    if (voice.provider === Providers.Microsoft && !voice.id.endsWith('Neural')) {
        return { deprecationMessage: 'Starting August 31st this voice will no longer be available' };
    }

    return {};
};

export function mapVoices(rawVoices?: ApiVoicesResponse): IVoice[] {
    let voices: IVoice[] = [];
    if (rawVoices) {
        voices = rawVoices
            .map((voice: IApiVoice | IVoice): IVoice[] => {
                if ('languages' in voice && Array.isArray(voice.languages)) {
                    return voice.languages.map((lang: any): IVoice => {
                        let voice_expanded: IVoice = {
                            ...voice,
                            ...getDeprecationMessage(voice),
                            language: lang.language,
                            locale: lang.locale,
                            ...(lang.accent ? { accent: lang.accent } : {}),
                            ...(lang.config ? { config: lang.config } : {}),
                            ...(lang.previewUrl ? { previewUrl: lang.previewUrl } : {}),
                        };
                        delete (voice_expanded as any).languages;
                        return voice_expanded;
                    });
                } else if ('language' in voice) {
                    // FIXME this is for backward compatibility, may be removed after the API will have migrated
                    return [
                        {
                            ...voice,
                            ...getDeprecationMessage(voice),
                            access: (voice as any).voiceAccess ?? voice.access,
                            styles: (voice as any).styleList ?? voice.styles ?? [],
                            language: (voice as any).localeName ?? voice.language,
                            provider: voice.provider ?? Providers.Afflorithmics,
                        },
                    ];
                } else {
                    logger.error('Voice object is invalid', voice);
                    return [];
                }
            })
            .flat();
    }
    return voices;
}
